import { Fragment, useContext } from 'react'
import {
  Card,
  Row,
  Col,
  Heading,
  Visible,
  Hidden,
  Stack
} from '@leroy-merlin-br/backyard-react-ui'
import { ChevronRight } from '@leroy-merlin-br/backyard-react-icons'

import { ContextVisibility } from 'reactShared/components/ContextVisibility'

import { ShowMore } from '../ShowMore'
import { EntryKeyContext } from '../../context/EntryKeyContext'
import { Description } from '../Description'
import * as S from './styled'

const TopContent = ({ searchType: propsSearchType }) => {
  const {
    pageInfo: {
      name,
      filterTitle,
      description,
      contents,
      video
    },
    searchType: stateSearchType,
    query: { term }
  } = useContext(EntryKeyContext)

  const searchType = propsSearchType || stateSearchType

  const searchDictionary = {
    strict: {
      term: `Você pesquisou: ${term?.value}`,
      description:
        'Também encontramos alguns conteúdos relacionados à sua busca, veja abaixo:'
    },
    fuzzy: {
      term: `Você pesquisou: ${term?.value}`,
      description:
        'Confira abaixo alguns produtos e conteúdos que você pode se interessar'
    },
    imageSearch: {
      term: 'Encontramos alguns produtos similares a sua imagem',
      description: 'Confira abaixo'
    },
    error: {
      term: `Não temos resultados para o termo "${term?.value}"`
    }
  }

  const renderVideoThumb = () => {
    const { title, picture, url } = video

    return (
      <S.VideoThumb href={url} title={title}>
        <img src={picture} alt={title} />

        <S.VideoTitle>
          <S.VideoThumbTitle as="h4" size="tera" noMargin>
            {title}
          </S.VideoThumbTitle>

          <S.VideoThumbSubtitle as="span" size="mega" noMargin bold>
            Assista ao vídeo
          </S.VideoThumbSubtitle>
        </S.VideoTitle>
      </S.VideoThumb>
    )
  }

  const renderContentList = (hasVideo) => {
    const MAX_CONTENTS = hasVideo ? 6 : 9

    const slicedContents = contents.slice(0, MAX_CONTENTS)

    return (
      <Fragment>
        {slicedContents.map((content) => (
          <S.ContentLink
            key={content.id}
            as="a"
            href={content.url}
            variant="outline"
            iconRight={ChevronRight}
          >
            {content.title}
          </S.ContentLink>
        ))}
      </Fragment>
    )
  }

  const renderContent = () => {
    if (searchType === 'error') {
      return <span>Realize uma nova busca.</span>
    }

    const CONTENT_SIZE = video ? 8 : 12

    const topContentDescription = searchType
      ? `<h3>${searchDictionary[searchType].description}</h3>`
      : description

    return (
      <ShowMore scrollToParent showFloatButton>
        <S.Wrapper>
          <Description description={topContentDescription} />

          {(video || !!contents.lenght) && (
            <Stack spacing="mega">
              <Heading size="mega" as="h3" noMargin>
                Veja também essas dicas Leroy Merlin
              </Heading>

              <Row>
                {video && (
                  <Col size={{ giga: 4 }}>
                    {renderVideoThumb()}
                  </Col>
                )}

                <Col size={{ giga: CONTENT_SIZE }}>
                  <S.ContentWrapper hasVideo={!!video}>
                    {!!contents.length && renderContentList(!!video)}
                  </S.ContentWrapper>
                </Col>
              </Row>
            </Stack>
          )}
        </S.Wrapper>
      </ShowMore>
    )
  }

  return (
    <S.Container>
      <Card>
        <S.TopContent type={searchType}>
          <Visible kilo untilKilo>
            <Heading size="tera" as="h1" noMargin>
              {searchType ? searchDictionary[searchType].term : name}{' '}
              {filterTitle}
            </Heading>
          </Visible>

          <Hidden kilo untilKilo>
            <Heading size="exa" as="h1" noMargin>
              {searchType ? searchDictionary[searchType].term : name}{' '}
              {filterTitle}
            </Heading>
          </Hidden>

          <ContextVisibility when={['assisted-sale', 'ecommerce']}>
            {description && renderContent()}
          </ContextVisibility>
        </S.TopContent>
      </Card>
    </S.Container>
  )
}
export default TopContent
